import type { CountryCode } from 'libphonenumber-js/min';

import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

export const getCountryCode = (value: string): CountryCode | undefined =>
  !value.startsWith('+') ? 'US' : undefined;

export const parsePhoneNumber = (
  value: string
): ReturnType<typeof parsePhoneNumberFromString> =>
  parsePhoneNumberFromString(value, getCountryCode(value));

/**
 * Formats a phone number into a string. Uses a national format for US numbers
 * and international format for the rest. If the phone number is invalid, it
 * returns the original value.
 */
export function formatPhoneNumber(value: string | number): string {
  const phoneNumber = parsePhoneNumber(String(value));
  if (!phoneNumber) return String(value);
  return phoneNumber.country === 'US'
    ? phoneNumber.formatNational()
    : phoneNumber.formatInternational();
}
